<script>
  // Render html component for render html with vue components inside
  export default {
    props: {
      html: {
        type: String,
        required: true,
      },
    },
    render(h) {
      const render = {
        components: {
          ContactButton: () =>
            import(/* webpackChunkName: "chunk-contact-button" */ './contact-button.vue'),
          SvgMcvVerified: () =>
            import(/* webpackChunkName: "chunk-svg-mcv-verified" */ './svg/mcv-verified.vue'),
          VerifiedBadgeFooter: () =>
            import(
              /* webpackChunkName: "chunk-verified-badge-footer" */ '../components/verified-badge-footer.vue'
            ),
          UiAlert: () => import(/* webpackChunkName: "chunk-ui-alert" */ './ui/ui-alert.vue'),
          SvgImageVerifiedAnimation: () =>
            import(
              /* webpackChunkName: "chunk-svg-image-verified-animation" */ './svg/image-verified-animation.vue'
            ),
        },
        template: '<div>' + this.html + '</div>',
      }
      return h(render)
    },
  }
</script>
